// import abi from "../abi.json";
import axios from "axios";
import abi from "../abi2.json";
import tokenIds from "../token.json";
import Web3 from "web3";
const { ethereum } = window;
const web3 = new Web3(ethereum);

// const address = "0xFAc96E4e3201e6928C1a2d3E8bd6B8d5072C7648";
const address = "0xE86ae8f38372d26F8ffAC37deba733a77f101Ac7";
const chainID = 1;
let network;

export const connectWallet = async () => {
  if (window.ethereum) {
    try {
      let obj;
      await web3.eth.net.getId().then(async (netId) => {
        network = netId;
        const addressArray = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        obj = {
          status: "👆🏽 Write a message in the text-field above.",
          address: addressArray[0],
          type: true,
        };
      });
      return obj;
    } catch (err) {
      return {
        address: "",
        status: "😥 " + err.message,
      };
    }
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://metamask.io/download.html`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};

export const checkConnection = async () => {
  if (window.ethereum) {
    try {
      await web3.eth.net.getId().then(async (netId) => {
        console.log(netId);
        network = netId;
        const addressArray = await window.ethereum.request({
          method: "eth_accounts",
        });
        if (addressArray.length > 0) {
          return true;
        } else {
          return false;
        }
      });
    } catch (err) {
      return false;
    }
  } else {
    return 1;
  }
};

export const getMint = async () => {
  const contract = new web3.eth.Contract(abi, address);
  const data = await contract.methods.getMinted().call();
  const value = [];
  console.log(data.length);
  for (var i = 0; i < data.length; i++) {
    console.log(i + 1 + " " + data[i]);
    const token = await contract.methods.ownerOf(data[i]).call();
    const obj = {
      id: data[i],
      address: token,
    };
    value.push(obj);
  }
  console.log(value);
  return value;
};

export const getCurrentWalletConnected = async () => {
  if (window.ethereum) {
    try {
      var netId = undefined;
      var promise = web3.eth.net.getId();
      await promise.then((result) => (netId = result));
      network = netId;

      const addressArray = await window.ethereum.request({
        method: "eth_accounts",
      });
      if (addressArray.length > 0) {
        return {
          address: addressArray[0],
          status: "👆🏽 Write a message in the text-field above.",
        };
      } else {
        return {
          address: "",
          status: "🦊 Connect to Metamask using the top right button.",
        };
      }
    } catch (err) {
      return {
        address: "",
        status: "😥 " + err.message,
      };
    }
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://metamask.io/download.html`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};

export const getAddress = async () => {
  const token = [];
  const contract = new web3.eth.Contract(abi, address);

  // console.log(tokenIds.length);
  // const IDs = await contract.methods
  //   .walletOfOwner("0x33Af4aEbEef943DceCEEd6645254E24A47B738c1")
  //   .call();
  // console.log(IDs);return;
  // var keyArray = tokenIds.map(function (item) {
  //   return item["id"];
  // });
  // console.log(keyArray);

  const add = "0x33Af4aEbEef943DceCEEd6645254E24A47B738c1";
  await tokenIds.map((item, i) => {
    if (item.address === add) {
      token.push(item.id);
    }
  });
  console.log(token);
  // return;
  const accounts = await web3.eth.getAccounts();

  let ETH_COST = 1000000000000000000;
  // let ETH_COST = 2000000000000000;
  // if (price === 1) {
  //   ETC_COST = 1000000000000000000;
  // } else {
  //   ETC_COST = 2000000000000000000;
  // }

  let GAS_LIMIT = 4172490;
  let status;

  try {
    await contract.methods
      .baje("0xdA67831129BAACeE73FCC44100F8F63298229e8E", [657, 1850])
      .send({
        from: accounts[0],
        to: address,
      })
      .then(function (result) {
        console.log(result);
      });
    status = {
      success: true,
      status: "🙌 NFT Successfully Minted",
    };
  } catch (error) {
    status = {
      success: false,
      status: "😥 Something went wrong: " + error.message,
    };
  }

  // const unique = [...new Set(tokenIds.map((item) => item.address))];
  // console.log(unique);
  // const contract = new web3.eth.Contract(abi, address);
  // const array = [];
  // if (window.ethereum) {
  //   for (let i = 1; i < 3000; i++) {
  //     try {
  //       const token = await contract.methods.ownerOf(i).call();
  //       array.push({
  //         id: i,
  //         address: token,
  //       });
  //       console.log(array);
  //     } catch (e) {
  //       console.log("no user");
  //     }
  //   }
  //   console.log(array);
  // }
};

const randomFunc = async (number) => {
  console.log(number);
  const length = [];
  if (window.ethereum) {
    const contract = new web3.eth.Contract(abi, address);
    for (let i = 0; i < number; i++) {
      const geNumber = async () => {
        var random = Math.floor(Math.random() * 3000) + 1;
        await web3.eth.net.getId().then(async (netId) => {
          if (netId != chainID) {
          } else {
            try {
              const token = await contract.methods.ownerOf(random).call();
              geNumber();
            } catch (error) {
              const minted = await contract.methods.getMinted().call();
              const condition = minted.includes(number);
              if (!condition) {
                length.push(random);
                console.log(length);

                // if (length.length.toFixed() === number.toFixed()) {
                //   console.log("same");
                //   return;
                // } else {
                //   geNumber();
                // }
              } else {
                geNumber();
              }
            }
          }
        });
      };
      await geNumber();
    }
    return length;
  }
};

export const mintNFT = async (number) => {
  //error handling
  if (number === "") {
    return {
      success: false,
      status: "❗Please make sure all fields are completed before minting.",
    };
  }

  const contract = new web3.eth.Contract(abi, address);
  const accounts = await web3.eth.getAccounts();

  let ETH_COST = 1000000000000000000;

  let GAS_LIMIT = 4172490;
  let totalGasLimit = String(GAS_LIMIT * number);
  let status;
  await web3.eth.net.getId().then(async (netId) => {
    if (netId != chainID) {
      status = {
        status: "👆🏽 Please connect to ETC Network.",
      };
    } else {
      try {
        const tokens = await randomFunc(number);
        let totalCostWei = String(ETH_COST * tokens.length);
        // console.log(tokens);
        await contract.methods
          .mint(tokens)
          .send({
            from: accounts[0],
            // gasLimit: String(totalGasLimit),
            to: address,
            value: totalCostWei,
          })
          .then(function (result) {
            // console.log(result);
          });

        for (var i = 0; i < tokens.length; i++) {
          console.log(tokens[i], accounts[0]);
          await axios
            .post("https://monkeydoapi.herokuapp.com/", {
              id: tokens[i],
              address: accounts[0],
            })
            .then(function (response) {
              console.log(response);
            })
            .catch(function (error) {
              console.log(error);
            });
        }
        status = {
          success: true,
          status: "🙌 NFT Successfully Minted",
        };
      } catch (error) {
        status = {
          success: false,
          status: "😥 Something went wrong: " + error.message,
        };
      }
    }
  });
  return status;
};

export const totalSupply = async () => {
  if (window.ethereum) {
    const contract = new web3.eth.Contract(abi, address);
    if (network == chainID) {
      try {
        const supply = await contract.methods.totalMinted().call();
        return supply;
        console.log(supply);
      } catch (error) {
        return {
          success: false,
          status: "😥 Something went wrong: " + error.message,
        };
      }
    } else {
      return 0;
    }
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://metamask.io/download.html`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};

export const walletOfOwner = async () => {
  if (window.ethereum) {
    const contract = new web3.eth.Contract(abi, address);
    const contract2 = new web3.eth.Contract(abi, address);
    const accounts = await web3.eth.getAccounts();

    try {
      const token = await contract.methods.walletOfOwner(accounts[0]).call();
      return token;
    } catch (error) {
      return {
        success: false,
        status: "😥 Something went wrong: " + error.message,
      };
    }
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://metamask.io/download.html`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};

export const Balance = async () => {
  if (window.ethereum) {
    const contract = new web3.eth.Contract(abi, address);
    const accounts = await web3.eth.getAccounts();
    await web3.eth.net.getId().then(async (netId) => {
      if (netId != chainID) {
        return {
          status: "👆🏽 Please connect to ETC Network.",
        };
      } else {
        try {
          const token = await contract.methods.balance().call({
            from: accounts[0],
          });
          return token;
        } catch (error) {
          return {
            success: false,
            status: "😥 Something went wrong: " + error.message,
          };
        }
      }
    });
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://metamask.io/download.html`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};

export const OwnerOf = async (id) => {
  if (window.ethereum) {
    const contract = new web3.eth.Contract(abi, address);
    await web3.eth.net.getId().then(async (netId) => {
      if (netId != chainID) {
        return {
          status: "👆🏽 Please connect to ETC Network.",
        };
      } else {
        try {
          const token = await contract.methods.ownerOf(id).call();
          console.log(token);
          return token;
        } catch (error) {
          return {
            success: false,
            status: "😥 Something went wrong: " + error.message,
          };
        }
      }
    });
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://metamask.io/download.html`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};

export const TransferNFTCall = async (to, token) => {
  //error handling
  if (to === "" || token === "") {
    return {
      success: false,
      status: "❗Please make sure all fields are completed before minting.",
    };
  }

  const contract = new web3.eth.Contract(abi, address);
  const accounts = await web3.eth.getAccounts();

  let status;
  await web3.eth.net.getId().then(async (netId) => {
    if (netId != chainID) {
      status = {
        status: "👆🏽 Please connect to ETC Network.",
      };
    } else {
      try {
        await contract.methods
          .transferFrom(accounts[0], to, token)
          .send({
            from: accounts[0],
          })
          .then(function (result) {
            // console.log(result);
          });
        status = {
          success: true,
          status: "🙌 NFT Successfully Transfered",
        };
      } catch (error) {
        status = {
          success: false,
          status: "😥 Something went wrong: " + error.message,
        };
      }
    }
  });
  return status;
};
